import React from 'react';
import PropTypes from 'prop-types';
import KpiSummary from '../../../commons/KpiSummary';

const PartnerStudentVariationSummary = (props) => (
  <KpiSummary
    title="Growth of students studying"
    isLoading={props.isLoading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    standardDeviationValue={props.standardDeviationValue}
    formatter={props.formatter}
  />
);

PartnerStudentVariationSummary.propTypes = {
  isLoading: PropTypes.bool,
  currentValue: PropTypes.string.isRequired,
  previousValue: PropTypes.string.isRequired,
  formatter: PropTypes.func.isRequired,
};

PartnerStudentVariationSummary.defaultProps = {
  isLoading: false,
};

export default PartnerStudentVariationSummary;
